import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service'
@Component({
  selector: 'app-help-section',
  templateUrl: './help-section.component.html',
  styleUrls: ['./help-section.component.css']
})
export class HelpSectionComponent implements OnInit {
  currentUser: string = '';
  roleId: string = '';
  lstHelpDataByRole = [];
  lstHelpData = [];
  constructor(public commonService: CommonService, private dataService: DataService, private router: Router,private memorystore: MemoryStorageService) { }


  ngOnInit(): void {
    // this.currentUser = this.commonService.getUserInfoFromLocalStorage('userName');
    // this.roleId = this.commonService.getUserInfoFromLocalStorage('roleId');
    this.currentUser = this.memorystore.getItem('userName');
    this.roleId = this.memorystore.getItem('roleId');
    this.getHelpSectionByRole(this.roleId);
  }
  getHelpSectionByRole(roleId: any) {
    this.lstHelpDataByRole = [];
    let params = new HttpParams();
    params = params.append("roleId", roleId);
    // params = params.append("projectId", this.commonService.getUserInfoFromLocalStorage('projectId'));
    params = params.append("projectId", this.memorystore.getItem('projectId'));
    this.dataService.getData('dashboard/helpsectionbyrole', params).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          this.lstHelpDataByRole = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        this.commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }
  getHelpSection(category: any) {
    // this.lstHelpData = [];
    // let params = new HttpParams();
    // params = params.append("category", event);  
    // this.dataService.getData('dashboard/help', params).subscribe((res) => {

    //   if (res != null && res.success == true) {
    //     let data = res.data;
    //     this.lstHelpData.push({'active': data[0]['active'],'category': data[0]['category'],'document_id':data[0]['document_id'],'document_name':data[0]['document_name'],
    //     'document_path': data[0]['document_path'],'icon':data[0]['icon'],'project_id':data[0]['project_id'],'role_id': data[0]['role_id'],'title': data[0]['title']});
    //     //this.lstHelpData.push({ 'File Name': 'DOA_Template_test1_1.xlsx', 'Time Stamp': '12-Sep-2021 3:23:16 PM', 'Action By': '745752', 'Status': 'SUCCESS', 'Download': 'Download File' });
    //   }
    // });
    // this.commonService.setUserInfoToLocalStorage('Category', category);
    this.memorystore.setItem('Category', category);
    this.router.navigate(['/help-section-details'], { state: { Category: category } });
  }

}
